import type { AppSnapshot, Plan, VpnState } from "./types";

export const plans: Plan[] = [
  { id: "two_days", label: "2 дня", price: 35, days: 2 },
  { id: "month", label: "1 месяц", price: 150, days: 30 },
  { id: "three_months", label: "3 месяца", price: 400, days: 90 },
];

export function createMockSnapshot(state: VpnState): AppSnapshot {
  return {
    vpn: {
      state,
      expiresAt: state === "active" ? "27.08.2026" : state === "expired" ? "20.08.2026" : null,
      daysLeft: state === "active" ? 24 : 0,
      deviceLimit: 3,
      regions: ["Германия", "Нидерланды"],
      subscriptionUrl: null,
      happUrl: null,
      happDirectUrl: null,
      lastPlanLabel: state === "never_had" ? null : "1 месяц",
    },
    account: {
      firstName: "Айдар",
      username: "@aidahar",
      isBlocked: false,
    },
  };
}
